module.exports = __webpack_public_path__ + "img/010.0856f82e.jpg";